<template>
  <div class="rubens-tube-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>火焰高度 ∝ 声波驻波节点</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Tube -->
          <rect x="50" y="140" width="300" height="20" fill="#444" stroke="#888" />
          
          <!-- Gas Entry -->
          <line x1="200" y1="160" x2="200" y2="180" stroke="#888" stroke-width="4" />

          <!-- Speaker -->
          <g transform="translate(30, 150)">
             <path d="M 0,-10 L 20,-20 L 20,20 L 0,10 Z" fill="#222" stroke="#888" />
             <path v-for="i in 3" :key="i" :d="`M ${25 + i*5}, -10 Q ${35 + i*5}, 0 ${25 + i*5}, 10`" fill="none" stroke="#888" stroke-width="1" />
          </g>

          <!-- The Flame Line (Standing Wave) -->
          <g v-for="n in 30" :key="n">
             <path :d="calcFlame(n)" :fill="flameColor" opacity="0.8">
                <animate attributeName="opacity" values="0.6;1;0.6" dur="0.1s" repeatCount="indefinite" />
             </path>
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>激发频率 Frequency: {{ freq }} Hz</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>调节音调 (频率)</label>
             <el-slider v-model="freq" :min="1" :max="5" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>鲁本斯管是一种演示声学驻波的经典物理装置。管内充满可燃气体，顶部有一排小孔。当扬声器发出声音时，管内形成**驻波**。声压越高的地方气体从小孔喷出的速度越慢（由伯努利公式可知，动压与静压成反比），从而形成参差不齐的火焰脊。火焰的高度直接绘制出了不可见的**波形图**。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RubensTubeViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      freq: 2,
      time: 0
    }
  },
  computed: {
    flameColor() { return "#ff7f50"; },
    flameHeight() {
       return Array.from({length: 30}, (_, i) => {
          let x = i / 29;
          return 15 + 25 * Math.abs(Math.sin(x * Math.PI * this.freq));
       });
    }
  },
  methods: {
    calcFlame(i) {
       let x = 60 + i * 9.5;
       let h = 15 + 25 * Math.abs(Math.sin((i/29) * Math.PI * this.freq));
       return `M ${x-2},140 Q ${x},${140-h} ${x+2},140 Z`;
    }
  }
}
</script>

<style scoped lang="scss">
.rubens-tube-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 127, 80, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
